/**
 * Configuracoes da INSTALACAO — globais, definidas no Console.
 *
 * Diferente de feature toggle (liga/desliga por plano e empresa) e de
 * preferencia de usuario: aqui sao parametros de comportamento que valem para
 * todo mundo na instalacao e que so o super admin muda.
 *
 * Guardadas como chave/valor em `tb_setting`. Texto no banco, tipado aqui:
 * uma tabela por parametro seria uma migration a cada ajuste de produto.
 */

/** Chaves conhecidas. Chave desconhecida no banco e ignorada na leitura. */
export const CHAVE_MINUTOS_ATE_AUSENTE = 'presenca.minutos_ate_ausente'

/**
 * Quanto tempo parado ate virar "ausente".
 *
 * Piso de 1 minuto e teto de 60 (decisao do usuario, 2026-09-12 05:30). O piso
 * evita que alguem zere e faca todo mundo piscar ausente entre uma tecla e
 * outra; o teto evita um valor tao alto que a funcao deixe de existir na
 * pratica.
 */
export const MINUTOS_ATE_AUSENTE_MIN = 1
export const MINUTOS_ATE_AUSENTE_MAX = 60

/** Vale enquanto ninguem tiver configurado nada. */
export const MINUTOS_ATE_AUSENTE_PADRAO = 20

/**
 * Normaliza o que veio do banco ou da tela.
 *
 * Ate a leitura precisa passar por aqui: o valor e texto livre no banco, e um
 * registro estragado a mao nao pode derrubar o app — cai no padrao.
 */
export function normalizarMinutosAteAusente(bruto: unknown): number {
  const numero = typeof bruto === 'number' ? bruto : Number.parseInt(String(bruto ?? ''), 10)
  if (!Number.isFinite(numero)) return MINUTOS_ATE_AUSENTE_PADRAO
  const inteiro = Math.trunc(numero)
  if (inteiro < MINUTOS_ATE_AUSENTE_MIN) return MINUTOS_ATE_AUSENTE_MIN
  if (inteiro > MINUTOS_ATE_AUSENTE_MAX) return MINUTOS_ATE_AUSENTE_MAX
  return inteiro
}

/** O conjunto de configuracoes que o cliente precisa conhecer. */
export type ConfiguracoesDaInstalacao = {
  minutosAteAusente: number
}

/** Texto curto para a tela: "20 minutos", "1 minuto", "1 hora". */
export function rotuloDeMinutos(minutos: number): string {
  if (minutos === 60) return '1 hora'
  if (minutos === 1) return '1 minuto'
  return `${minutos} minutos`
}
